define('viewmodels/Weightings_Thresholds/SanctionsInherentWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'SanctionsInherentWeightings';
    var checkWeighting = 0;
    var checkOverallWeighting = 0;
    var SIWViewModel = {
        cacheViews: false,
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        RiskAreaList: ko.observableArray(),
        RiskFactorList: ko.observableArray(),
        BusinessUnitsList: ko.observableArray(),
        WeightingsList: ko.observableArray(),
        RAWeightingsList: ko.observableArray(),
        RAId: ko.observable(),
        RAName: ko.observable(),
        saveWeightings: saveWeightings,
        saveValues: saveValues,
        copyData: copyData,
        RiskAreaTabClick: RiskAreaTabClick,
        ClickedRiskAreaId: ko.observable(),
        ClickedRiskAreaName: ko.observable(),
        BusinessLevelsList: ko.observableArray(),
        ClickedLevelId: ko.observable(),
        ClickedLevelName: ko.observable(),
        ShowLevelsTab: ko.observable(),
        ShowDetailsTab: ko.observable(),
        BusinessLevelDetailsList: ko.observableArray(),
        BusinessLevelTabClick: BusinessLevelTabClick,
        BusinessLevelDetailTabClick: BusinessLevelDetailTabClick,
        ClickedLevelDetailId: ko.observable(),
        ClickedLevelDetailName: ko.observable(),
        LastClickedLevelDetailId: ko.observable(),
        BULWeightingsList: ko.observableArray(),
        BULOverallWeightingsList: ko.observableArray(),
        BusinessUnitsLowestLevelList: ko.observableArray(),
        WeightingsType: ko.observable(), //this specifies the type of the wightings. RA:Area|OA:Overall|BUL:business unit level|BULOverall :business unit level
        LevelIdNumber: ko.observable(),
        //To save weightings
        WeightingsListSave: ko.observableArray(),
        OverallWeightingsListSave: ko.observableArray(),
        BULWeightingsListSave: ko.observableArray(),
        BULOverallWeightingsListSave: ko.observableArray(),
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        countLevelEntry: ko.observable(0),
        LevelErrorStatus: ko.observable(0),
        RIskAreaTabClicked: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
    };

    return SIWViewModel;

    var GetAllRiskAreaAjax = {};
    var GetAllRiskFactorAjax = {};
    var GetWeightingsAjax = {};
    var SaveWeightingsAjax = {};
    var GetOverAllWeightingsAjax = {};
    var GetBULevelWeightingsAjax = {};
    var GetBUlowestLevelsAjax = {};

    function ImplementTabbing() {
        try {


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function InputChange() {
        SIWViewModel.InputChangeEvent(true);
    }

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {
            SIWViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
                SIWViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                    if (SIWViewModel.appsecurity.isConfigurationFreeze() == 1) {
                        SIWViewModel.appsecurity.WriteAccess(false);
                        GetAllRiskAreas(GetAllRiskAreaAjax);
                    }
                    else {
                        GetAllRiskAreas(GetAllRiskAreaAjax);
                    }
                })
            })
            SIWViewModel.countEntry(0);
            SIWViewModel.countLevelEntry(0);
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');

            GetAllRiskAreaAjax = {
                //url: "/api/WeightingsThresholds/GetAllRiskAreas?RiskAreaType=SANC",
                url: "/api/Configuration/GetAllRiskAreas",
                data: { "AssessmentType": "SANC", "AreaType": "ALL" },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };

            var options = {
                url: "/api/WeightingsThresholds/GetAllBusinessUnits",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            getAllBusinessUnits(options);

            var url = window.location.pathname
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "SanctionsInherentWeightings") {
                $(document).on('change', 'input', function (e) {
                    GetTotalWeightings();
                    GetTotalWeightingsBUL();
                    GetTotalWeightingsBULOverall();
                });
            }
            $(document).on('keydown', 'input', function (e) {
                var url = window.location.pathname
                var filename = url.substring(url.lastIndexOf('/') + 1);
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0;
                if ((id.substring(0, 13)) == "txt_weighting") {
                    result = id.substring(("txt_weightingSANC").length, id.length);
                    controlID = 'txt_weightingSANC';
                    rows = SIWViewModel.RiskFactorList().length;
                    columns = SIWViewModel.BusinessUnitsList().length;
                }
                else if ((id.substring(0, 14)) == "txt_Oweighting") {
                    result = id.substring(("txt_OweightingSANC").length, id.length);
                    controlID = 'txt_OweightingSANC';
                    rows = SIWViewModel.RiskAreaList().length - 1// removing the Overall SANC Inherent Weightings from the list;
                    columns = SIWViewModel.BusinessUnitsList().length;
                }
                else if ((id.substring(0, 16)) == "txt_BULweighting") {
                    result = id.substring(("txt_BULweightingSANC").length, id.length);
                    controlID = 'txt_BULweightingSANC';
                    rows = SIWViewModel.BusinessUnitsLowestLevelList().length;
                    columns = SIWViewModel.RiskAreaList().length;
                }
                else if ((id.substring(0, 17)) == "txt_BULOweighting") {
                    result = id.substring(("txt_BULOweightingSANC").length, id.length);
                    controlID = "txt_BULOweightingSANC";
                    rows = SIWViewModel.RiskAreaList().length - 1;
                    columns = SIWViewModel.BusinessLevelDetailsList().length - 1;

                }

                if (e.which == 9 && filename == "SanctionsInherentWeightings" && rows > 1) {


                    var columnandrownuo = result.indexOf("_");
                    if (controlID == "txt_OweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    } else if (controlID == "txt_weightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    else if (controlID == "txt_BULweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    else if (controlID == "txt_BULOweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    rowno = rowno + 1;

                    if (rowno == rows) {
                        rowno = 0;
                        columnno = columnno + 1;
                    }
                    for (var i = columnno; i < columns; i++) {
                        if (controlID == "txt_OweightingSANC") {
                            //   e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno;
                            // $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        } else if (controlID == "txt_weightingSANC") {
                            // e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.RAId()
                            // $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        }
                        else if (controlID == "txt_BULweightingSANC") {
                            //  e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.ClickedLevelDetailId()
                            // $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        }
                        else if (controlID == "txt_BULOweightingSANC") {
                            //  e.preventDefault();
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.ClickedLevelDetailId()
                            // $("#" + tobefocusedid).focus();
                            // $("#" + tobefocusedid).select();
                        }
                        if ($("#" + tobefocusedid).prop('disabled')) {
                            columnno = columnno + 1;
                        }
                        else {
                            break;
                        }
                    }


                    if (columns == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else if (controlID == "txt_OweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno;
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    } else if (controlID == "txt_weightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.RAId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULOweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SIWViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetTotalWeightings() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);
        if (SIWViewModel.RAId() == "SANC_OVERALL") {
            for (var k = 0; k < SIWViewModel.BusinessUnitsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < SIWViewModel.RiskAreaList().length - 1; i++) {

                    var x = "#txt_OweightingSANC" + i + "_" + k;
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var rowcount = k;
                if (isNaN(sum)) {
                    $("#txt_OweightingSANC" + rowcount + SIWViewModel.RAId()).val(0);
                } else {
                    $("#txt_OweightingSANC" + rowcount + SIWViewModel.RAId()).val(sum);
                }

                if (sum == 100) {
                    $("#txt_OweightingSANC" + rowcount + SIWViewModel.RAId()).css('color', '#000000')
                    $("#txt_OweightingSANC" + rowcount + SIWViewModel.RAId()).css("background-color", "#cccccc")
                } else {
                    $("#txt_OweightingSANC" + rowcount + SIWViewModel.RAId()).css('color', 'red')

                }
            }


        }
        else {
            for (var k = 0; k < SIWViewModel.BusinessUnitsList().length; k++) {
                var sum = parseFloat(0);
                for (var i = 0; i < SIWViewModel.RiskFactorList().length; i++) {

                    var x = "#txt_weightingSANC" + i + "_" + k + "_" + SIWViewModel.RAId();
                    sum = parseFloat(sum) + parseFloat($(x).val());
                }
                var rowcount = k;
                if (isNaN(sum)) {
                    $("#txt_weighting" + rowcount + SIWViewModel.RAId()).val(0);
                } else {
                    $("#txt_weighting" + rowcount + SIWViewModel.RAId()).val(sum);
                }

                if (sum == 100) {
                    $("#txt_weighting" + rowcount + SIWViewModel.RAId()).css('color', '#000000')
                    $("#txt_weighting" + rowcount + SIWViewModel.RAId()).css("background-color", "#cccccc")
                } else {

                    $("#txt_weighting" + rowcount + SIWViewModel.RAId()).css('color', 'red')



                }
            }
        }
    }
    function GetTotalWeightingsBUL() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 1; k <= SIWViewModel.RiskAreaList().length; k++) {

            var sum = parseFloat(0);
            for (var i = 0; i < SIWViewModel.BusinessUnitsLowestLevelList().length; i++) {

                var x = "#txt_BULweightingSANC" + i + "_" + k + "_" + SIWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k - 1;
            if (isNaN(sum)) {
                $("#txt_BULweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).val(0);
            } else {
                $("#txt_BULweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).val(sum);
            }

            if (sum == 100) {
                $("#txt_BULweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css('color', '#000000')
                $("#txt_BULweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc")
            } else {
                $("#txt_BULweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css('color', 'red')

            }
        }

    }
    function GetTotalWeightingsBULOverall() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < SIWViewModel.BusinessLevelDetailsList().length - 1; k++) { //-1 as the last item of the list is overall tab

            var sum = parseFloat(0);
            for (var i = 0; i < SIWViewModel.RiskAreaList().length - 1; i++) {

                var x = "#txt_BULOweightingSANC" + i + "_" + k + "_" + SIWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k;
            if (isNaN(sum)) {
                $("#txt_BULOweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).val(0);
            } else {
                $("#txt_BULOweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).val(sum);
            }

            if (sum == 100) {
                $("#txt_BULOweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css('color', '#000000')
                $("#txt_BULOweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc")
            } else {
                $("#txt_BULOweightingSANC" + rowcount + SIWViewModel.ClickedLevelDetailId()).css('color', 'red')

            }
        }

    }
    function getAllBusinessUnits(options) {
        try {
            $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResultObj, status) {
            try {
                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    SIWViewModel.BusinessUnitsList(mappedBusinessUnits);
                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                    $("#NobusinessUnitserrorSANC").show();
                    $("#RaTab").hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };

    };
    function getAllBusinessUnitlowestLevels(entityId) {
        try {
            GetBUlowestLevelsAjax = {
                url: "/api/Configuration/getAllLowestLevelUnitsByLevels",
                data: { "entityId": entityId, "asst_type": "SANC" },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlowestLevelsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnitlowestLevels() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {
                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    SIWViewModel.BusinessUnitsLowestLevelList(mappedBusinessUnits);
                    GetBUlevelWeightings();

                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnitlowestLevels() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    };
    function GetAllRiskAreas(GetAllRiskAreaAjax) {
        try {
            $.ajax(GetAllRiskAreaAjax)
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "" && jsonResult[0].RiskAreaName != null) {
                    jsonResult[jsonResult.length] = { RiskAreaId: "SANC_OVERALL", RiskAreaName: "Overall Sanctions Inherent Weightings", RiskAreaType: "SANC" }
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    SIWViewModel.RiskAreaList(mappedRiskAreaList);
                    $('#RaTab').tabs();
                    $('#RaTab').tabs('refresh');
                    $('#RaTab').tabs({ active: 0 });
                    $($('#RiskAreaUl li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else {
                    app.showMessage("Risk Area configurations not in place.", "Error", ["OK"]);
                    $("#NoAreasserrorSANC").show();
                    $('#RaTab').hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    }
    function GetAllRiskLevels(RiskAreaID) {
        try {

            $.ajax({
                url: "/api/Configuration/getAllBusinessUnitLevels",
                data: { "type": "SANC", "Page_Type": "W" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskLevels() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult[0].BuLevelName != null) {
                    var mappedBULevelsList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });
                    SIWViewModel.BusinessLevelsList(mappedBULevelsList);
                    SIWViewModel.ShowLevelsTab(true);
                    var max = SIWViewModel.BusinessLevelsList()[0].LevelID();
                    var id = SIWViewModel.BusinessLevelsList()[0].LevelID()
                    for (i = 0; i < SIWViewModel.BusinessLevelsList().length; i++) {
                        if (max < SIWViewModel.BusinessLevelsList()[i].LevelID()) {
                            max = SIWViewModel.BusinessLevelsList()[0].LevelID();
                        }
                    }
                    for (i = 0; i < SIWViewModel.BusinessLevelsList().length; i++) {
                        if (max == SIWViewModel.BusinessLevelsList()[i].LevelID()) {
                            SIWViewModel.BusinessLevelsList()[i].LevelID('LevelOverall');
                        }
                    }
                    $('#RfTab').tabs();
                    $('#RfTab').tabs('refresh');
                    $('#RfTab').tabs({ active: 0 });
                    $($('#RiskFactorUl li').get(0)).trigger('click');
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SIWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskLevels() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskLevels() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskLevels() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    };
    function GetRiskLevelDetails(LevelID, LevelName) {
        try {

            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": LevelID },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.length != 0) {
                        $('#RiskLevelDetailsTabDiv').show();
                        $('#RiskLevelDetailsTabDiv').removeClass('alert-warning');
                        jsonResult[jsonResult.length] = { BuLevelDetailId: LevelID + "OVERALL", BuLevelDetailName: LevelName + "-OVERALL" }
                        var mappedBULevelsList = $.map(jsonResult, function (result) {
                            return new BusinessLevelDetail(result);
                        });
                        SIWViewModel.BusinessLevelDetailsList(mappedBULevelsList);

                        //$('#RdTab').tabs();
                        //$('#RdTab').tabs('refresh');
                        //$('#RdTab').tabs({ active: 0 });
                        //$($('#RiskLevelDetailUl li').get(0)).trigger('click');
                    }
                    else {
                        SIWViewModel.BusinessLevelDetailsList([]);
                        $('#RiskLevelDetailsTabDiv').empty();
                        $('#RiskLevelDetailsTabDiv').addClass('alert-warning')
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SIWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    };
    //functions to add divs
    function addNewDivTab(data) {
        try {
            $('#RiskAreaTabDiv').append(
          '<div id="SANCTabDiv-' + data.RiskAreaId() + '" style="overflow:hidden;"></div>');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function addNewDivTabBULevel(BuDetailId) {
        try {
            $('#RiskLevelDetailsTabDiv').empty();
            $('#RiskLevelDetailsTabDiv').append(
          '<div id="SANCTabDiv-' + BuDetailId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTabBULevel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function addNewDivTabBULevelOverall(AreaId) {
        try {
            $('#RiskLevelTabDiv').append(
          '<div id="SANCTabDiv-' + AreaId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTabBULevel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function GetRiskFactors() {
        try {
            GetAllRiskFactorAjax = {
                url: "/api/WeightingsThresholds/GetAllRiskfactorAreaWise",
                data: { "RiskAreaId": SIWViewModel.RAId(), "AssessmentType": "SANC" },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetAllRiskFactorAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskFactors() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {
                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        $('#NoSancFactorserror').hide();
                        SIWViewModel.RiskFactorList([]);
                        SIWViewModel.RiskFactorList(mappedRiskFactors);
                        GetWeightingsAjax = {
                            url: "/api/WeightingsThresholds/GetAllRiskAreaWeightings?RiskAreaId=" + SIWViewModel.RAId() + "&RiskAreaType=SANC",
                            type: "GET",
                            headers: appsecurity.getSecurityHeaders()
                        };
                        GetWeightings(GetWeightingsAjax);
                    }
                    else {
                        app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                        $('#NoSancFactorserror').show();
                        $('#RiskAreaTabDiv').hide();
                    }
                } else {
                    $('#NoSancFactorserror').show();
                    $('#RiskAreaTabDiv').hide();
                    app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactor() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetWeightings(GetWeightingsAjax) {
        try {
            $.ajax(GetWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkWeighting = 1;
                    SIWViewModel.WeightingsList(mappedWeightings);
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkWeighting = 0;
                    WeightingsTable(checkWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

    }

    function WeightingsTable(checkWeighting) {
        try {
            var selectedRow, selectedCol;
            var j = SIWViewModel.BusinessUnitsList().length;
            var rows = SIWViewModel.RiskFactorList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < SIWViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            $('#outerdiv').show();
            for (var i = 0; i < SIWViewModel.RiskAreaList().length; i++) {
                $('#SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).show();
            }
            for (var i = 0; i < SIWViewModel.RiskAreaList().length; i++) {
                document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            }
            var TabData =
                       '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SIWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnAMLInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SIWViewModel.RAId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SIWViewModel.RAId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-2 col-lg-1 control-label no-padding control-label-key">Risk Area Name : </label>' +
                      '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label control-label-val">' + SIWViewModel.RAName() + '</label>' +
                      '</div><label id="lblSANCError-' + SIWViewModel.RAId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                        '<label id="lblSANCError" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none">No Data Available.</label>' +


            //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Factor Name</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>' +
            //Corner cell end


           //Header Business units
                    '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SIWViewModel.RAId() + '" style="width:65%;">' +
                        '<table>' +
                            '<tr>'
            for (var i = 0 ; i < j; i++) {


                TabData += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

            }
            TabData += '</tr>' +

                       '</table>' +
                      '</div>' +

           //Header Business units end

            //Row headers
                         '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SIWViewModel.RAId() + '" style="width:100%">' +
                             '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = SIWViewModel.RiskFactorList()[i].RiskFactorName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabData += '<tr><td class="tbl-weightings-cell Weightingsheader" style="min-height:42px;height:' + colHeight + 'em !important;">';
                TabData += factText;
                TabData += '</td></tr>';
            }
            TabData += '</table></div>' +
            //Row headers end




                       //Data 
                         '<div class="wclscscroll table-content" id="clscroll-content' + SIWViewModel.RAId() + '" style="width:65%;">' +
            '<table id="tblSANCWeightings-' + SIWViewModel.RAId() + '" ><tbody>';
            for (var i = 0; i < rows; i++) {
                var factText = SIWViewModel.RiskFactorList()[i].RiskFactorName();
                var length = parseInt(factText.length);
                TabData += '<tr id="' + SIWViewModel.RiskFactorList()[i].RiskFactorId() + '">';
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                for (var k = 0; k < (j) ; k++) {
                    if (SIWViewModel.appsecurity.WriteAccess() == false) {
                        TabData += '<td id=" ' + SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class="disabled tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';
                    }
                    else {
                        TabData += '<td id=" ' + SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class="tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';
                    }
                    selectedCol = SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                    if (checkWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < SIWViewModel.WeightingsList().length; val++) {
                            if (SIWViewModel.WeightingsList()[val].BuId() == SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //SIWViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (SIWViewModel.WeightingsList()[val].Id() == SIWViewModel.RiskFactorList()[i].RiskFactorId() && SIWViewModel.WeightingsList()[val].BuId() == SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {


                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="' + SIWViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            if (SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.WeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                        }
                    } else {
                        if (SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.WeightingsList().push(newObj);
                            TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                        else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.WeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                    }

                    TabData += '</div></td>';


                }
                TabData += '</tr>';
            }


            TabData += '</tbody></table></div>';
            //Total  cell

            TabData += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabData += "Total"
            TabData += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>' +
//Total cell end  
            //Total Data
            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SIWViewModel.RAId() + '">' +
                 '<table>' +
                     '<tr>'
            for (var m = 0; m < SIWViewModel.BusinessUnitsList().length; m++) {
                TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabData += '<input type="text" disabled style="background-color: #cccccc;"  class="form-control form-controlWT" id="' + 'txt_weighting' + m + SIWViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
                TabData += '</td>';

                //ko.applyBindingsToNode($('#txt_weighting-' + m + SIWViewModel.RAId()), { event: { keyup: SIWViewModel.InputChange } }, SIWViewModel);
            }
            TabData += '</tr>' +
            '</table></div>';
            document.getElementById('SANCTabDiv-' + SIWViewModel.RAId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnSANCSave-' + SIWViewModel.RAId()), { click: SIWViewModel.saveWeightings }, SIWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + SIWViewModel.RAId()), { click: SIWViewModel.copyData }, SIWViewModel);


            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_weightingSANC' + i + '_' + k + '_' + SIWViewModel.RAId()), { event: { keyup: SIWViewModel.InputChange } }, SIWViewModel);

                }
            }

            ImplementWeightingTableSecurity();
            $("#clscroll-content" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop($("#clscroll-content" + SIWViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop());
            });
            $('#loadingMainImgDivAMLRA_SANC').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function ImplementWeightingTableSecurity() {
        try {
            if (SIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody').find('input').length; i++) {
                    $($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementWeightingTableSecurity() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetOverallWeightings() {
        try {
            GetOverAllWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetOverallWeightings?RiskAreaType=SANC&Type=A",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetOverAllWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetOverallWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkOverallWeighting = 1;
                    SIWViewModel.RAWeightingsList([]);
                    SIWViewModel.RAWeightingsList(mappedWeightings);
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkOverallWeighting = 0;
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax Success in GetOverallWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOverallWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function OverallWeightingsTable(checkOverallWeighting) {
        try {
            var selectedRow, selectedCol;
            var rows = SIWViewModel.RiskAreaList().length - 1;
            var j = SIWViewModel.BusinessUnitsList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < SIWViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            //for (var i = 0; i <= SIWViewModel.RiskAreaList().length; i++) {
            //    document.getElementById('AMLTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            //}

            var TabDataOverAll = '</br>' +
                        '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SIWViewModel.appsecurity.WriteAccess()) {
                TabDataOverAll += '<span id="spnAMLInherent" class="pull-right">' +

                   '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopyOverall" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +

                           '<i class="fa fa-copy"></i>Copy to All' +
                       '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSaveOverall" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                    '<i class="fa fa-check"></i>Save' +
                       '</button></span>';
            }


            TabDataOverAll += '<label style="padding-left:1em" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label control-label-border">Overall Inherent Weightings</label>' +
           '</div><label id="lblSANCError-' + SIWViewModel.RAId() + '" class="control-label alert alert-danger col-xs-12 col-sm-12 col-md-12 col-lg-12 alerts-inherent" style="display:none"></label>' +
                       //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucolumnheight + ' em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Area Name</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>' +
            //Corner cell end
            //Header Business units
                    '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SIWViewModel.RAId() + '" style="width:65%;">' +
                        '<table>' +
                            '<tr>'
            for (var i = 0 ; i < j; i++) {


                TabDataOverAll += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

            }
            TabDataOverAll += '</tr>' +

                       '</table>' +
                      '</div>' +

           //Header Business units end
                       //Row headers
                         '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SIWViewModel.RAId() + '" style="width:100%">' +
                             '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = SIWViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabDataOverAll += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                TabDataOverAll += SIWViewModel.RiskAreaList()[i].RiskAreaName();
                TabDataOverAll += '</td></tr>'
            }
            TabDataOverAll += '</table></div>' +
            //Row headers end
                                   //Data 
                         '<div class="wclscscroll table-content" id="clscroll-content' + SIWViewModel.RAId() + '" style="width:65%;">' +
            '<table  id="tblSANCWeightingsOverall"><tbody>';
            for (var i = 0; i < rows; i++) {
                var factText = SIWViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = SIWViewModel.RiskAreaList()[i].RiskAreaId();
                TabDataOverAll += '<tr id="' + SIWViewModel.RiskAreaList()[i].RiskAreaId() + '">';
                for (var k = 0; k < (j) ; k++) {
                    // TabDataOverAll += '<td class="tbl-weightings-cell">';
                    if (SIWViewModel.appsecurity.WriteAccess() == false) {
                        TabDataOverAll += '<td id="' + SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="disabled tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    }
                    else {
                        TabDataOverAll += '<td id="' + SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';

                    }
                    selectedCol = SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                    if (checkOverallWeighting == 1) {
                        var check_new = true;
                        for (var val = 0; val < SIWViewModel.RAWeightingsList().length; val++) {
                            if (SIWViewModel.RAWeightingsList()[val].BuId() == SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //SIWViewModel.WeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_OweightingSANC' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                            else if (SIWViewModel.RAWeightingsList()[val].Id() == SIWViewModel.RiskAreaList()[i].RiskAreaId() && SIWViewModel.RAWeightingsList()[val].BuId() == SIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {
                                TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_OweightingSANC' + i + '_' + k + '"value="' + SIWViewModel.RAWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                            }
                        }
                        if (check_new) {
                            if (SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_OweightingSANC' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_OweightingSANC' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';
                            }
                        }
                    } else {
                        if (SIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.RAWeightingsList().push(newObj);
                            TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + SIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                        }
                        else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.RAWeightingsList().push(newObj);
                            TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_OweightingSANC' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';

                        }
                    }
                    TabDataOverAll += '</div></td>';
                }

                TabDataOverAll += '</tr>';
                //if (i == rows - 1) {


                // }



            }


            TabDataOverAll += '</tbody></table></div>';
            //totalheader table
            //Total  cell

            TabDataOverAll += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabDataOverAll += '<td   style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabDataOverAll += "Total"
            TabDataOverAll += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>' +
//Total cell end  
            //Total Data
            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SIWViewModel.RAId() + '">' +
                 '<table>' +
                     '<tr>'
            for (var i = 0; i < SIWViewModel.BusinessUnitsList().length; i++) {
                TabDataOverAll += '<td style="height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabDataOverAll += '<input type="text" disabled style="background-color:#cccccc"class="form-control form-controlWT" id="' + 'txt_OweightingSANC' + i + SIWViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
                TabDataOverAll += '</td>';
            }
            TabDataOverAll += '</tr>' +
            '</table></div>';
            document.getElementById('SANCTabDiv-' + SIWViewModel.RAId()).innerHTML = TabDataOverAll;
            ko.applyBindingsToNode($('#btnSANCSaveOverall'), { click: SIWViewModel.saveWeightings }, SIWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopyOverall'), { click: SIWViewModel.copyData }, SIWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {
                    ko.applyBindingsToNode($('#txt_OweightingSANC' + i + '_' + k), { event: { keyup: SIWViewModel.InputChange } }, SIWViewModel);
                }
            }
            ImplementOverallTableSecurity();
            $("#clscroll-content" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop($("#clscroll-content" + SIWViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + SIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop());
            });
            $('#loadingMainImgDivAMLRA_SANC').hide();
            $('#loadingMainImgDivAMLRA_Levels_OverALL_SANC').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function ImplementOverallTableSecurity() {
        try {
            if (SIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSANCWeightingsOverall tbody').find('input').length; i++) {
                    $($('#tblSANCWeightingsOverall tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    //Functions to build the list for save/update
    function buildSaveWeightingsList() {
        if (SIWViewModel.WeightingsType() == 'RA') {
            buildSaveRAWeightingsList();
        }
        else if (SIWViewModel.WeightingsType() == 'OA') {
            buildSaveOverallWeightingsList();
        }
        else if (SIWViewModel.WeightingsType() == 'BULOverall') {
            buildSaveBULOverallWeightingsList();
        }
        else if (SIWViewModel.WeightingsType() == 'BUL') {
            buildSaveBULWeightingsList();
        }
    }
    function buildSaveRAWeightingsList() {
        try {
            SIWViewModel.WeightingsListSave([]);
            var rows = SIWViewModel.RiskFactorList().length;
            var cols = SIWViewModel.BusinessUnitsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weightingSANC' + i + '_' + j + '_' + SIWViewModel.RAId();
                    var newObj = new WeightingModel({
                        'Id': SIWViewModel.RiskFactorList()[i].RiskFactorId(), 'BuId': SIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    SIWViewModel.WeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveOverallWeightingsList() {
        try {
            SIWViewModel.OverallWeightingsListSave([]);
            var rows = SIWViewModel.RiskAreaList().length - 1;
            var cols = SIWViewModel.BusinessUnitsList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_OweightingSANC' + i + '_' + j;
                    var newObj = new WeightingModel({
                        'Id': SIWViewModel.RiskAreaList()[i].RiskAreaId(), 'BuId': SIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    SIWViewModel.OverallWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveBULWeightingsList() {
        try {
            SIWViewModel.BULWeightingsListSave([]);
            var rows = SIWViewModel.BusinessUnitsLowestLevelList().length;
            var cols = SIWViewModel.RiskAreaList().length - 1;
            for (i = 0; i < rows; i++) {
                for (j = 1; j <= cols; j++) {
                    var txtid = '#txt_BULweightingSANC' + i + '_' + j + '_' + SIWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': SIWViewModel.RiskAreaList()[j - 1].RiskAreaId(), 'BuId': SIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    SIWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveBULOverallWeightingsList() {
        try {
            SIWViewModel.BULOverallWeightingsListSave([]);
            var rows = SIWViewModel.RiskAreaList().length - 1;
            var cols = SIWViewModel.BusinessLevelDetailsList().length - 1;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULOweightingSANC' + i + '_' + j + '_' + SIWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': SIWViewModel.RiskAreaList()[i].RiskAreaId(), 'BuId': SIWViewModel.BusinessLevelDetailsList()[j].DetailId(),
                        'WeightingValue': $(txtid).val()
                    });
                    SIWViewModel.BULOverallWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function saveWeightings() {
        try {
            $('#loadingMainImgDivAMLRA_SANC').show();
            $('#loadingMainImgDivAMLRA_Levels_OverALL_SANC').hide();
            $('#RiskAreaTabDiv').hide();
            SIWViewModel.SaveButtonClick(true);
            if (SIWViewModel.WeightingsType() == 'BULOverall') {
                saveBULOverallWeightings();
            }
            else if (SIWViewModel.WeightingsType() == 'BUL') {
                saveBULWeightings();
            }
            else {
                $("#lblSANCError-" + SIWViewModel.RAId()).hide();
                var cols = SIWViewModel.BusinessUnitsList().length;
                if (SIWViewModel.RAId() == "SANC_OVERALL") {
                    var rows = SIWViewModel.RiskAreaList().length - 1;
                    var valid = 1;
                    var check = 0;
                    for (var i = 0; i < cols; i++) {
                        var sum = 0;
                        for (var j = 0; j < rows; j++) {
                            if ($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                                $($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                            }
                            if (!$.isNumeric($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Non-numeric values are not allowed.');
                                check = 1;
                            }
                            else if ($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Value should be in range of (0-100).');
                            }
                            else if ((!isNaN($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) && ($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value % 1 != 0) && (!checkDecimal($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value))) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Decimal upto 2 places is allowed.');
                                check = 1;
                            }
                            else {
                                sum += parseFloat($($('#tblSANCWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                            }
                        }
                        if (valid == 0) {
                            SIWViewModel.ErrorStatus(1);
                            $('#loadingMainImgDivAMLRA_SANC').hide();
                            $('#RiskAreaTabDiv').show();
                        }
                        if (sum != 100 && sum != 0) {
                            if (check == 0) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Total for weightings across factors should be 100% for business unit ' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name());
                                break;
                            }
                        }
                    }
                    if (valid == 1) {
                        try {
                            buildSaveWeightingsList();
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SaveOverallWeightings?RiskAreaType=SANC&Filter=A&RiskAreaId=" + SIWViewModel.RAId(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                                async: false,
                                data: JSON.stringify($.map(SIWViewModel.OverallWeightingsListSave(), function (item) {
                                    return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                                }))
                            })
                            .success(ajaxSuccessOverall)
                            .fail(ajaxFailOverall);
                        }
                        catch (e) {

                            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveOverallWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }

                        function ajaxSuccessOverall(jsonResult, status) {
                            try {
                                if (jsonResult != null&& jsonResult>0) {
                                    SIWViewModel.RAWeightingsList([]);

                                    if (!(SIWViewModel.RIskAreaTabClicked())) {
                                        $('#tblAMLWeightingsOverall').remove();
                                        GetOverallWeightings();
                                        GetTotalWeightings();
                                    }
                                    logger.logSuccess('Overall Inherent Weightings saved successfully.', 'Success', system.getModuleId(SIWViewModel), true);
                                } else {
                                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SIWViewModel), true);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveOverallWeightings() method in SanctionsInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }

                        function ajaxFailOverall(error, status) {
                            try {
                                if (error.status == 401) {
                                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                                }
                                else {
                                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveOverallWeightings() method in SanctionsInherentWeightings.js';
                                    logger.logMessage(msg);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveOverallWeightings() method in SanctionsInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                    }
                }
                else {
                    var rows = SIWViewModel.RiskFactorList().length;
                    var valid = 1;
                    var check = 0;
                    for (var i = 0; i < cols; i++) {
                        var sum = 0;
                        for (var j = 0; j < rows; j++) {
                            if ($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                                $($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                            }
                            if (!$.isNumeric($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Non-numeric values are not allowed.');
                                valid = 0;
                                check = 1;
                                break;
                            }
                            else if ($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Value should be in range of (0-100).');
                                check = 1;
                                valid = 0;
                                break;
                            }
                            else if ((!isNaN($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) && ($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value % 1 != 0) && (!checkDecimal($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value))) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Decimal upto 2 places is allowed.');
                                check = 1;
                                break;
                            }
                            else {
                                sum += parseFloat($($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                            }
                        }

                        if (sum != 100 && sum != 0) {
                            if (check == 0) {
                                valid = 0;
                                $("#lblSANCError-" + SIWViewModel.RAId()).show();
                                $("#lblSANCError-" + SIWViewModel.RAId()).text('Total for weightings across factors should be 100% for business unit ' + SIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name());
                                break;
                            }
                        }
                    }
                    if (valid == 0) {
                        SIWViewModel.ErrorStatus(1);
                        $('#loadingMainImgDivAMLRA_SANC').hide();
                        $('#RiskAreaTabDiv').show();
                    }
                    if (valid == 1) {
                        try {
                            buildSaveWeightingsList();
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SaveRiskFactorWeightings?RiskAreaType=SANC&Filter=F&RiskAreaId=" + SIWViewModel.RAId(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                                async: false,
                                data: JSON.stringify($.map(SIWViewModel.WeightingsListSave(), function (item) {
                                    return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                                }))
                            })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }

                        function ajaxSuccess(jsonResult, status) {
                            try {
                                if (jsonResult != null && jsonResult>0) {
                                    $('#tblSANCWeightings-' + SIWViewModel.RAId()).remove();
                                    GetWeightings(GetWeightingsAjax);
                                    GetTotalWeightings();
                                    logger.logSuccess('Weightings for Risk Area saved successfully.', 'Success', system.getModuleId(SIWViewModel), true);
                                } else {
                                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SIWViewModel), true);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightings() method in SanctionsInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }

                        function ajaxFail(error, status) {
                            try {
                                if (error.status == 401) {
                                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                                }
                                else {
                                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightings() method in SanctionsInherentWeightings.js';
                                    logger.logMessage(msg);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in SanctionsInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function saveBULWeightings() {
        try {
            var colsBUL = SIWViewModel.RiskAreaList().length - 1;
            var rows = SIWViewModel.BusinessUnitsLowestLevelList().length;
            var tableId = '#tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Total for weightings across business levels should be 100% for risk area  ' + SIWViewModel.RiskAreaList()[i].RiskAreaName());
                        break;
                    }
                }
            }
            if (valid == 0) {
                SIWViewModel.ErrorStatus(1);
                                $('#loadingMainImgDivAMLRA_SANC').hide();
                $('#RiskAreaTabDiv').show();
            }
            if (valid == 1) {
                try {
                    buildSaveWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOverallWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SIWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(SIWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult > 0) {
                            $(tableId).remove();
                            GetBUlevelWeightings();
                            checkBULevelWeighting = 1;
                            BULevelWeightingsTable(checkBULevelWeighting);
                            GetTotalWeightingsBUL();
                            $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Inherent Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(SIWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SIWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function saveBULOverallWeightings() {
        try {
            $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).hide();
            var cols = SIWViewModel.BusinessLevelDetailsList().length - 1;// -1 to remove the overall
            var rows = SIWViewModel.RiskAreaList().length - 1;// -1 to remove the overall
            var valid = 1;
            var check = 0;
            var tableIdBULOverall = '#tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId();
            for (var i = 0; i < cols; i++) {
                var sum = 0;
                for (var j = 0; j < rows; j++) {
                    if ($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                        $($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if ($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else if ((!isNaN($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) && ($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value % 1 != 0) && (!checkDecimal($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value))) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed.');
                        check = 1;
                    }
                    else {
                        sum += parseFloat($($(tableIdBULOverall + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('The total for weightings across factors should be 100% for business unit level detail ' + SIWViewModel.BusinessLevelDetailsList()[i].DetailName() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                SIWViewModel.ErrorStatus(1);
                $('#loadingMainImgDivAMLRA_SANC').hide();
                $('#RiskAreaTabDiv').show();
            }
            if (valid == 1) {
                try {
                    buildSaveWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOverallWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SIWViewModel.ClickedLevelDetailId(),//to save the bu level overall wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        async: false,
                        data: JSON.stringify($.map(SIWViewModel.BULOverallWeightingsListSave(), function (item) {
                            return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCcall in saveWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            //var mappedData = $.map(jsonResult, function (result) {
                            //    return new WeightingModel(result);
                            //});
                            SIWViewModel.BULOverallWeightingsList([]);
                            // SIWViewModel.BULOverallWeightingsList(mappedData);
                            $(tableIdBULOverall).remove();
                            checkBULevelOverallWeighting = 1;
                            GetBUlevelOverallWeightings();
                            BULevelOverallWeightingsTable(checkBULevelOverallWeighting);
                            GetTotalWeightingsBULOverall();
                            logger.logSuccess('Weightings for Risk Area saved successfully.', 'Success', system.getModuleId(SIWViewModel), true);
                        } else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SIWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULOverallWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function checkDecimal(value) {
        try {
            var num = parseFloat(value);
            if (num.toFixed(1) == value) {
                return true;
            }
            return num.toFixed(2) == value;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkDecimal() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function copyDataRA() {
        try {
            var cols = SIWViewModel.BusinessUnitsList().length;
            $("#lblSANCError-" + SIWViewModel.RAId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            if (SIWViewModel.RAId() != "SANC_OVERALL") {
                rows = SIWViewModel.RiskFactorList().length;
            } else {
                rows = SIWViewModel.RiskAreaList().length - 1;
            }
            var copytoallvalues = []
            for (var i = 0; i < rows; i++) {
                if (SIWViewModel.RAId() != "SANC_OVERALL") {
                    var txtValue = $($('#tblSANCWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                    //var txtValue = $($('#tblAMLWeightings-' + SIWViewModel.RAId() + ' tbody tr').get(i)).find('td').get(1).firstChild.firstChild.value;
                } else {
                    var txtValue = $($('#tblSANCWeightingsOverall tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                }
                if (txtValue == "") {

                    $("#lblSANCError-" + SIWViewModel.RAId()).show();
                    $("#lblSANCError-" + SIWViewModel.RAId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblSANCError-" + SIWViewModel.RAId()).show();
                        $("#lblSANCError-" + SIWViewModel.RAId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblSANCError-" + SIWViewModel.RAId()).show();
                        $("#lblSANCError-" + SIWViewModel.RAId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblSANCError-" + SIWViewModel.RAId()).show();
                        $("#lblSANCError-" + SIWViewModel.RAId()).text('Decimal upto 2 places is allowed.');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SIWViewModel.ErrorStatus(1);
                $('#loadingMainImgDivAMLRA_SANC').hide();
                $('#RiskAreaTabDiv').show();
            }
            if (valid == 0) {
                if (SIWViewModel.RAId() != "SANC_OVERALL") {
                    SIWViewModel.WeightingsList([]);
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = SIWViewModel.RiskFactorList()[i].RiskFactorId()
                        for (var j = 0; j < cols; j++) {

                            selectedColId = SIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                            wValue = WeightingsValue[i];
                            var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                            SIWViewModel.WeightingsList.push(newObj);
                        }
                    }
                    $('#tblSANCWeightings-' + SIWViewModel.RAId()).remove();
                    WeightingsTable(1);
                    GetTotalWeightings();
                }
                else {
                    SIWViewModel.RAWeightingsList([]);
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = SIWViewModel.RiskAreaList()[i].RiskAreaId();
                        for (var j = 0; j < cols; j++) {

                            selectedColId = SIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                            wValue = WeightingsValue[i];
                            var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                            SIWViewModel.RAWeightingsList.push(newObj);
                        }
                    }
                    $('#tblSANCWeightingsOverall').remove();
                    OverallWeightingsTable(1);
                    GetTotalWeightings();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyDataBUL() {
        try {
            var cols = SIWViewModel.RiskAreaList().length - 1;
            $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            rows = SIWViewModel.BusinessUnitsLowestLevelList().length;

            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                    $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed.');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SIWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                SIWViewModel.BULWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = SIWViewModel.BusinessUnitsLowestLevelList()[i].DetailId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = SIWViewModel.RiskAreaList()[i].RiskAreaId();
                        wValue = WeightingsValue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SIWViewModel.BULWeightingsList.push(newObj);
                    }
                }
                $('#tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId()).remove();
                BULevelWeightingsTable(1);
                GetTotalWeightingsBUL();
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyDataBULOverall() {
        try {
            var cols = SIWViewModel.BusinessLevelDetailsList().length - 1;
            $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            rows = SIWViewModel.RiskAreaList().length - 1;

            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                    $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SIWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed.');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SIWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                SIWViewModel.BULOverallWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = SIWViewModel.RiskAreaList()[i].RiskAreaId();
                    for (var j = 0; j < cols; j++) {
                        selectedColId = SIWViewModel.BusinessLevelDetailsList()[j].DetailId();
                        wValue = WeightingsValue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SIWViewModel.BULOverallWeightingsList.push(newObj);
                    }
                }
                $('#tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId()).remove();
                BULevelOverallWeightingsTable(1);
                GetTotalWeightingsBULOverall();
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataBULOverall() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyData(event) {
        SIWViewModel.CopyDataButtonClicked(true);
        if (SIWViewModel.WeightingsType() == 'RA') {
            copyDataRA();
        }
        else if (SIWViewModel.WeightingsType() == 'OA') {
            copyDataRA();
        }
        else if (SIWViewModel.WeightingsType() == 'BUL') {
            copyDataBUL();
        }
        else if (SIWViewModel.WeightingsType() == 'BULOverall') {
            copyDataBULOverall();
        }
    }

    function saveValues(event, type) {
        try {
            $("#lblSANCError-" + SIWViewModel.RAId()).hide();
            var selectedColId;
            var selectedRowId = event.currentTarget.parentNode.parentNode.parentNode.id;
            if (type == "F") {
                selectedColId = $('#tblSANCWeightings-' + SIWViewModel.RAId()).find('th').get($('#tblSANCWeightings-' + SIWViewModel.RAId()).find($(event.currentTarget.parentNode.parentNode)).index()).id;
            } else {
                selectedColId = $('#tblSANCWeightingsOverall').find('th').get($('#tblSANCWeightingsOverall').find($(event.currentTarget.parentNode.parentNode)).index()).id;
            }
            if (event.currentTarget.value == "") {
                event.currentTarget.value = 0;
            }
            else {
                if (!$.isNumeric(event.currentTarget.value)) {
                    $("#lblSANCError-" + SIWViewModel.RAId()).show();
                    $("#lblSANCError-" + SIWViewModel.RAId()).text('Non-numeric entry is not allowed.');
                }
                else if (event.currentTarget.value < 0 || event.currentTarget.value > 100) {
                    $("#lblSANCError-" + SIWViewModel.RAId()).show();
                    $("#lblSANCError-" + SIWViewModel.RAId()).text('Value should be in range of (0-100).');
                }
                else if ((!isNaN(event.currentTarget.value)) && (event.currentTarget.value % 1 != 0) && (!checkDecimal(event.currentTarget.value))) {
                    $("#lblSANCError-" + SIWViewModel.RAId()).show();
                    $("#lblSANCError-" + SIWViewModel.RAId()).text("Decimal upto only 2 places is allowed.");
                }
                else {
                    if (type == "F") {
                        for (var i = 0, j = SIWViewModel.WeightingsList().length; i < j; i++) {
                            if (SIWViewModel.WeightingsList()[i].Id() == selectedRowId && SIWViewModel.WeightingsList()[i].BuId() == selectedColId) {
                                SIWViewModel.WeightingsList()[i].WeightingValue(parseFloat(event.currentTarget.value));
                            }
                        }
                    } else {
                        for (var i = 0, j = SIWViewModel.RAWeightingsList().length; i < j; i++) {
                            if (SIWViewModel.RAWeightingsList()[i].Id() == selectedRowId && SIWViewModel.RAWeightingsList()[i].BuId() == selectedColId) {
                                SIWViewModel.RAWeightingsList()[i].WeightingValue(parseFloat(event.currentTarget.value));
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveValues() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetBUlevelWeightings() {
        try {
            GetBUlevelWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": "SANC", "DeUid": SIWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlevelWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelWeighting = 1;
                    SIWViewModel.BULWeightingsList(mappedWeightings);

                    BULevelWeightingsTable(checkBULevelWeighting);
                    GetTotalWeightingsBUL();
                }
                else {
                    checkBULevelWeighting = 0;
                    BULevelWeightingsTable(checkBULevelWeighting);
                    GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function BULevelWeightingsTable(checkBULevelWeighting) {
        try {

            var selectedRow, selectedCol;
            var rows = SIWViewModel.BusinessUnitsLowestLevelList().length;
            var j = SIWViewModel.RiskAreaList().length - 1;
            for (var i = 0; i < SIWViewModel.BusinessLevelDetailsList().length; i++) {
                var id = document.getElementById('SANCTabDiv-' + SIWViewModel.BusinessLevelDetailsList()[i].DetailId());
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.BusinessLevelDetailsList()[i].DetailId()).innerHTML = "";
                }
            }

            for (var i = 0; i < SIWViewModel.RiskAreaList().length - 1; i++) {
                var id = document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                }

            }
            var TabData =
                       '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SIWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveWeightings" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-2 control-label no-padding control-label-key">Business Unit Level Detail : </label>' +
                       '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label control-label-val">' + SIWViewModel.ClickedLevelDetailName() + '</label>' +
                        '</div><label id="lblSANCError-' + SIWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                   '<div id="outerdiv"><div id="innerdiv"><table id="tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId() + '" class="table table-bordered table-condensed" cellspacing="1">' +
                    '<thead>' +
                        '<tr>';
            var buHeight;
            var tdHeight;
            for (var i = 0; i < SIWViewModel.BusinessLevelDetailsList().length; i++) {
                colHeight = Math.ceil(SIWViewModel.BusinessLevelDetailsList()[i].DetailName().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            for (var i = 0 ; i <= j; i++) {

                if (i == 0) {
                    TabData += '<th class="site_name headcol">Risk Areas/Business Units</th>';
                }
                else {
                    TabData += '<th class="site_name long" id="' + SIWViewModel.RiskAreaList()[i - 1].RiskAreaId() + '" title="' + SIWViewModel.RiskAreaList()[i - 1].RiskAreaName() + '">' + SIWViewModel.RiskAreaList()[i - 1].RiskAreaName() + '</th>';
                }
                //TabData += '</th>';
            }
            TabData += '</tr>' +
                '</thead>' +
                '<tbody >';
            for (var i = 0; i < rows; i++) {
                selectedRow = SIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID();
                TabData += '<tr id="' + SIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID() + '">';
                for (var k = 0; k < (j + 1) ; k++) {

                    if (k == 0) {
                        TabData += '<td class="tbl-weightings-cell headcol">';
                        TabData += SIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name();
                        TabData += '</td>';
                    }
                    else {
                        TabData += '<td class="tbl-weightings-cell long"><div class="input-group">';
                        selectedCol = SIWViewModel.RiskAreaList()[k - 1].RiskAreaId();
                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < SIWViewModel.BULWeightingsList().length; val++) {
                                if (SIWViewModel.BULWeightingsList()[val].Id() == SIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID() && SIWViewModel.BULWeightingsList()[val].BuId() == SIWViewModel.RiskAreaList()[k - 1].RiskAreaId()) {


                                    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="' + SIWViewModel.BULWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                    }

                }

                TabData += '</tr>';
                if (i == rows - 1) {

                    TabData += '<tr>'
                    TabData += '<td class="tbl-weightings-cell headcol">';
                    TabData += "Total"
                    TabData += '</td>';

                    for (l = 0; l < SIWViewModel.RiskAreaList().length - 1; l++) {
                        TabData += '<td class="tbl-weightings-cell long"><div class="input-group">';
                        TabData += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_BULweightingSANC' + l + SIWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                        TabData += '</td>';
                    }
                    TabData += '</tr>';
                }

            }

            TabData += '</tbody>' +
                    '</table></div></div>';
            document.getElementById('SANCTabDiv-' + SIWViewModel.ClickedLevelDetailId()).innerHTML = TabData;

            ko.applyBindingsToNode($('#btnSANCSave-' + SIWViewModel.ClickedLevelDetailId()), { click: SIWViewModel.saveWeightings }, SIWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + SIWViewModel.ClickedLevelDetailId()), { click: SIWViewModel.copyData }, SIWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {
                    ko.applyBindingsToNode($('#txt_BULweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId()), { event: { keyup: SIWViewModel.InputChange } }, SIWViewModel);
                }
            }
            ImplementWeightingTableSecurity();
            $('#loadingMainImgDivAMLRA_SANC').hide();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementWeightingBULevelTableSecurity() {
        try {
            if (SIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblSACNWeightingsBU-' + SIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementWeightingBULevelTableSecurity() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetBUlevelOverallWeightings() {
        try {
            GetBUlevelWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": "SANC", "DeUid": SIWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlevelWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelOverallWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelOverallWeighting = 1;
                    SIWViewModel.BULOverallWeightingsList(mappedWeightings);

                    BULevelOverallWeightingsTable(checkBULevelOverallWeighting);
                    GetTotalWeightingsBULOverall(); //call totals
                }
                else {
                    checkBULevelOverallWeighting = 0;
                    BULevelOverallWeightingsTable(checkBULevelOverallWeighting);
                    GetTotalWeightingsBULOverall(); //call totals
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelOverallWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function BULevelOverallWeightingsTable(checkBULevelOverallWeighting) {
        try {
            if (SIWViewModel.BusinessLevelDetailsList().length != 0) {
                checkBULevelWeighting = 1;
                var selectedRow, selectedCol;
                var rows = SIWViewModel.RiskAreaList().length - 1;//-1 to removing the overall tab
                var j = SIWViewModel.BusinessLevelDetailsList().length - 1;//-1 to removing the overall tab
                var buHeight;
                var tdHeight;
                for (var i = 0; i < SIWViewModel.BusinessLevelDetailsList().length; i++) {
                    colHeight = Math.ceil(SIWViewModel.BusinessLevelDetailsList()[i].DetailName().length / 13)
                    if (i == 0) {
                        buHeight = colHeight;

                    }
                    if (buHeight < colHeight) {
                        buHeight = colHeight;
                    }
                }
                tdHeight = 3;
                if (buHeight > 1) {
                    tdHeight = tdHeight + ((buHeight - 1) * 1.5);
                }
                var bucoulmnheight = tdHeight / 2;
                for (var i = 0; i < SIWViewModel.BusinessLevelDetailsList().length; i++) {// this is for removing the previous tables from HTML
                    var id = document.getElementById('SANCTabDiv-' + SIWViewModel.BusinessLevelDetailsList()[i].DetailId());
                    if (id == null || id == undefined || id == '') {

                    }
                    else {
                        document.getElementById('SANCTabDiv-' + SIWViewModel.BusinessLevelDetailsList()[i].DetailId()).innerHTML = "";
                    }
                }

                for (var i = 0; i < SIWViewModel.RiskAreaList().length - 1; i++) {
                    var id = document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                    if (id == null || id == undefined || id == '') {

                    }
                    else {
                        document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                    }

                }

                var TabData = '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
                if (SIWViewModel.appsecurity.WriteAccess()) {
                    TabData += '<span id="spnAMLInherent" class="pull-right">' +
                            '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                                '<i class="fa fa-copy"></i> Copy to All' +
                            '</button>' +
                            '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                                '<i class="fa fa-check"></i> Save' +
                            '</button></span>';
                }
                //'<label class="col-xs-3 col-sm-3 col-md-3 col-lg-2 control-label no-padding">Business Unit Level Detail : </label>' +
                TabData += '<label style="padding-left:1em"class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label control-label-border">' + SIWViewModel.ClickedLevelDetailName() + '</label>' +
                            '</div><label id="lblSANCError-' + SIWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                //'<table id="tblAMLOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId() + '" class="table table-bordered table-condensed" cellspacing="1">' +
                // '<thead>' +
                //     '<tr>'+
         //Corner cell
                '<div class="wclscscroll corner-header">' +
                    '<table style="width:100%">' +
                          '<tr>' +
                                                 '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Level Detail</th>' +


                         '</tr>' +
                         '<tr>' +
                          '<th class="site_name label-info headcol-min1 text-center" title="Risk Area Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Area Name</th>' +
                          '</tr>' +
                       '</table>' +
                  '</div>' +
         //Corner cell end
         //Header Business units
                        '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SIWViewModel.RAId() + '" style="width:65%;">' +
                            '<table>' +
                                '<tr>'


                for (var i = 0 ; i < j; i++) {
                    //here akshay


                    TabData += '<th class="site_name long label-info" style="height:' + tdHeight + 'em;" id="' + SIWViewModel.BusinessLevelDetailsList()[i].DetailId() + '" title="' + SIWViewModel.BusinessLevelDetailsList()[i].DetailName() + '">' + SIWViewModel.BusinessLevelDetailsList()[i].DetailName() + '</th>';

                    //TabData += '</th>';
                }

                TabData += '</tr>' +

                                  '</table>' +
                                 '</div>';

                //Header Business units end
                //Row headers
                TabData += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SIWViewModel.RAId() + '" style="width:100%">' +
                    '<table>';
                for (var i = 0; i < rows; i++) {
                    var factText = SIWViewModel.RiskAreaList()[i].RiskAreaName();
                    var length = parseInt(factText.length);
                    var colHeight = parseInt((Math.ceil(length / 40)));
                    colHeight = colHeight + 4;


                    TabData += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                    TabData += SIWViewModel.RiskAreaList()[i].RiskAreaName();
                    TabData += '</td></tr>'
                }
                TabData += '</table></div>';
                //Row headers end
                //Data 
                TabData += '<div class="wclscscroll table-content" id="clscroll-content' + SIWViewModel.RAId() + '" style="width:65%;">' +
    '<table id="tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId() + '" ><tbody>';
                for (var i = 0; i < rows; i++) {
                    selectedRow = SIWViewModel.RiskAreaList()[i].RiskAreaId();
                    TabData += '<tr id="' + SIWViewModel.RiskAreaList()[i].RiskAreaId() + '">';
                    var factText = SIWViewModel.RiskAreaList()[i].RiskAreaName();
                    var length = parseInt(factText.length);
                    var colHeight = parseInt((Math.ceil(length / 40)));
                    colHeight = colHeight + 4;
                    for (var k = 0; k < (j) ; k++) {
                        if (SIWViewModel.appsecurity.WriteAccess() == false) {
                            TabData += '<td id=' + SIWViewModel.BusinessLevelDetailsList()[k].DetailId() + ' style="min-height:42px;height:' + colHeight + 'em !important;" class="disabled tbl-weightings-cell long weightingspadding"><div class="input-group">';
                        }
                        else {
                            TabData += '<td id=' + SIWViewModel.BusinessLevelDetailsList()[k].DetailId() + ' style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';

                        }
                        selectedCol = SIWViewModel.BusinessLevelDetailsList()[k].DetailId();
                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < SIWViewModel.BULOverallWeightingsList().length; val++) {
                                if (SIWViewModel.BULOverallWeightingsList()[val].Id() == SIWViewModel.RiskAreaList()[i].RiskAreaId() && SIWViewModel.BULOverallWeightingsList()[val].BuId() == SIWViewModel.BusinessLevelDetailsList()[k].DetailId()) {


                                    TabData += '<input  type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULOweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="' + SIWViewModel.BULOverallWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SIWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULOweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SIWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULOweightingSANC' + i + '_' + k + '_' + SIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';


                    }

                    TabData += '</tr>';
                }
                TabData += '</tbody></table></div>';
                //Total  cell

                TabData += '<div class="wclscscroll corner-header">' +
                    '<table>' +
               '<tr>';

                TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
                TabData += "Total"
                TabData += '</td>' +

                '</tr>' +

             '</table>' +
        '</div>' +
    //Total cell end  
                //Total Data
                '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SIWViewModel.RAId() + '">' +
                     '<table>' +
                         '<tr>'
                for (l = 0; l < SIWViewModel.BusinessLevelDetailsList().length - 1; l++) {
                    TabData += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    TabData += '<input type="text" disabled style="background-color:#cccccc"class="form-control form-controlWT" id="' + 'txt_BULOweightingSANC' + l + SIWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                    TabData += '</td>';
                }
                TabData += '</tr>' +
                '</table></div>';
                document.getElementById('SANCTabDiv-' + SIWViewModel.ClickedLevelDetailId()).innerHTML = TabData;

                ko.applyBindingsToNode($('#btnSANCSave-' + SIWViewModel.ClickedLevelDetailId()), { click: SIWViewModel.saveWeightings }, SIWViewModel);
                ko.applyBindingsToNode($('#btnSANCCopy-' + SIWViewModel.ClickedLevelDetailId()), { click: SIWViewModel.copyData }, SIWViewModel);
                ImplementWeightingTableSecurity();
                $("#clscroll-content" + SIWViewModel.RAId()).scroll(function () {
                    $("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop($("#clscroll-content" + SIWViewModel.RAId()).scrollTop());
                    $("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
                    $("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft($("#clscroll-content" + SIWViewModel.RAId()).scrollLeft());
                });

                $("#clscroll-column-headers" + SIWViewModel.RAId()).scroll(function () {
                    $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + SIWViewModel.RAId()).scrollLeft());
                });

                $("#clscroll-column-footer" + SIWViewModel.RAId()).scroll(function () {
                    $("#clscroll-content" + SIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + SIWViewModel.RAId()).scrollLeft());
                });

                $("#clscroll-row-headers" + SIWViewModel.RAId()).scroll(function () {
                    $("#clscroll-content" + SIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + SIWViewModel.RAId()).scrollTop());
                });
            }
            else {
                $('#RiskLevelDetailsTabDiv').css('font-weight', "bold");
                $('#RiskLevelDetailsTabDiv').get(0).innerHTML = "There are no Organizational Sub Levels configured for this Organizational Level."
            }
            $('#loadingMainImgDivAMLRA_SANC').hide();
            $('#loadingMainImgDivAMLRA_Levels_SANC').hide();
            $('#SANCTabDiv-' + SIWViewModel.ClickedLevelDetailId()).show();
            $('#RiskAreaTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementOverallWeightingBULevelTableSecurity() {
        try {
            if (SIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblSANCOverallWeightingsBUL-' + SIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementOverallWeightingBULevelTableSecurity() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }


    //---------------------------------------------------------------------Model Definition Starts Here------------------------------------------------------------------------------
    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            if ($('<div/>').html(item.IsQualitative).text() == "1") {
                self.IsQualitative = ko.observable(true);
            }
            else {
                self.IsQualitative = ko.observable(false);
            }
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function BusinessUnits(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuId);
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuName).text());
            self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function WeightingModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.BuId = ko.observable(item.BuId);
            self.WeightingValue = ko.observable(item.WeightingValue);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingModel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BusinessLevelModel(item) {
        try {
            var self = this;
            self.LevelID = ko.observable($('<div/>').html(item.BuLId).text());
            self.LevelName = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };
    function BusinessLevelDetail(item) {
        try {
            var self = this;
            self.DetailId = ko.observable($('<div/>').html(item.BuLevelDetailId).text());
            self.DetailName = ko.observable($('<div/>').html(item.BuLevelDetailName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function ResetBULevels() {
        SIWViewModel.ClickedLevelId('');
        SIWViewModel.ClickedLevelName('');
        SIWViewModel.ClickedLevelDetailId('');
        SIWViewModel.ClickedLevelDetailName('');
    };

    function RiskAreaTabClick(data, event) {
        try {
            $('#loadingMainImgDivAMLRA_SANC').show();
            $('#RiskAreaTabDiv').hide();
            SIWViewModel.RIskAreaTabClicked(true);
            if (SIWViewModel.appsecurity.WriteAccess() == false || SIWViewModel.appsecurity.WriteAccess() == "false") {
                SIWViewModel.countEntry(0);
            }
            if (SIWViewModel.countEntry() == 0) {
                SIWViewModel.countEntry(1);
                SIWViewModel.WeightingsType('');
                SIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
                SIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
                SIWViewModel.RAId(data.RiskAreaId());
                SIWViewModel.RAName(data.RiskAreaName());
                if (SIWViewModel.RAId() == "SANC_OVERALL") {
                    //$('#SANCTabDiv-' + SIWViewModel.RAId()).show();
                    $('#NoSancFactorserror').hide();
                    GetAllRiskLevels(data.RiskAreaId());

                }
                else {
                    SIWViewModel.countLevelEntry(0);
                    SIWViewModel.WeightingsType('RA');
                    SIWViewModel.ShowLevelsTab(false);
                    ResetBULevels();

                    GetRiskFactors();
                }
            }
            else if ((SIWViewModel.InputChangeEvent() || SIWViewModel.CopyDataButtonClicked()) && SIWViewModel.SaveButtonClick() == false) {
                SIWViewModel.InputChangeEvent(false);
                SIWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        if (SIWViewModel.RAId() == "SANC_OVERALL") {
                            if (SIWViewModel.ClickedLevelId() == 'LevelOverall') {
                                $('#btnSANCSaveOverall').click();
                            }
                            else {

                                $('#btnSANCSave-' + SIWViewModel.ClickedLevelDetailId()).click();
                            }
                        }
                        else {
                            SIWViewModel.countLevelEntry(0);
                            $('#btnSANCSave-' + SIWViewModel.RAId()).click();
                        }
                        //SIWViewModel.countEntry(0);
                        if (SIWViewModel.ErrorStatus() == 1) {
                            SIWViewModel.ErrorStatus(0);
                            $('#' + SIWViewModel.RAId()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SIWViewModel.SaveButtonClick(false);
                            SIWViewModel.countEntry(0);
                            $('#' + SIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                            RiskAreaTabClick(data, event);
                        }
                    }
                    else if (SIWViewModel.ErrorStatus() == 0) {
                        SIWViewModel.WeightingsType('');
                        SIWViewModel.countEntry(1);
                        //SIWViewModel.ErrorStatus(1);
                        $('#' + SIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                        SIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
                        SIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
                        SIWViewModel.RAId(data.RiskAreaId());
                        SIWViewModel.RAName(data.RiskAreaName());
                        if (SIWViewModel.RAId() == "SANC_OVERALL") {
                            GetAllRiskLevels(data.RiskAreaId());

                        }
                        else {
                            SIWViewModel.countLevelEntry(0);
                            SIWViewModel.WeightingsType('RA');
                            SIWViewModel.ShowLevelsTab(false);
                            ResetBULevels();

                            GetRiskFactors();
                        }
                    }
                })

            }
            else {
                SIWViewModel.InputChangeEvent(false);
                SIWViewModel.SaveButtonClick(false);
                SIWViewModel.CopyDataButtonClicked(false);
                SIWViewModel.countEntry(0);
                $('#' + SIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                RiskAreaTabClick(data, event);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in SANCInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelTabClick(data, event) {
        try {
            $('#SANCTabDiv-' + SIWViewModel.ClickedLevelDetailId()).hide();
            $('#loadingMainImgDivAMLRA_Levels').show();
            if (SIWViewModel.appsecurity.WriteAccess() == false || SIWViewModel.appsecurity.WriteAccess() == "false") {
                SIWViewModel.countLevelEntry(0);
            }
            SIWViewModel.RIskAreaTabClicked(false);
            SIWViewModel.ClickedLevelId(data.LevelID());
            SIWViewModel.ClickedLevelName(data.LevelName());
            SIWViewModel.LastClickedLevelDetailId(SIWViewModel.ClickedLevelDetailId());
            if (SIWViewModel.countLevelEntry() == 0) {
                SIWViewModel.countLevelEntry(1);
                var id = document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId());
                if (id != null && id != undefined && id != '') {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                }
                for (var i = 0; i < SIWViewModel.RiskAreaList().length; i++) {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                }
                var idRA = document.getElementById('SANCTabDiv-' + SIWViewModel.RAId());
                if (idRA != null && idRA != undefined && idRA != '') {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.RAId()).innerHTML = "";
                }

                if (SIWViewModel.ClickedLevelId() == 'LevelOverall') {
                    $('#SANCTabDiv-' + SIWViewModel.RAId()).show();
                    $('#loadingMainImgDivAMLRA_Levels_OverALL_SANC').show();
                    SIWViewModel.ClickedLevelDetailId(SIWViewModel.ClickedLevelId());
                    SIWViewModel.WeightingsType('OA');
                    SIWViewModel.ShowDetailsTab(false);
                    addNewDivTabBULevelOverall(SIWViewModel.RAId());
                    GetOverallWeightings();
                }
                else {
                    SIWViewModel.WeightingsType('BUL');
                    SIWViewModel.ShowDetailsTab(true);
                    $('#loadingMainImgDivAMLRA_Levels_SANC').show();
                    if (Number.isInteger(data.LevelID())) {
                        GetRiskLevelDetails(data.LevelID(), data.LevelName());

                    }
                    else {
                        SIWViewModel.LevelIdNumber(data.LevelID().match(/\d/g).join(""));
                        GetRiskLevelDetails(SIWViewModel.LevelIdNumber(), data.LevelName());
                    }
                    if (data.LevelID().toString().includes('OVERALL')) {
                        data.LevelID(data.LevelID());
                        data.LevelName(data.LevelName());
                    } else {
                        data.LevelID(data.LevelID() + 'OVERALL')
                        data.LevelName(data.LevelName());
                    }
                    BusinessLevelDetailTabClick(data);
                }
            }
            else if ((SIWViewModel.InputChangeEvent() || SIWViewModel.CopyDataButtonClicked()) && SIWViewModel.SaveButtonClick() == false) {
                SIWViewModel.InputChangeEvent(false);
                SIWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, {
                    buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus"
                })
                .then(function (option) {
                    if (option == "Save") {
                        if (SIWViewModel.LastClickedLevelDetailId() == 'LevelOverall') {
                            $('#btnSANCSaveOverall').click();
                        }
                        else {
                            $('#btnSANCSave-' + SIWViewModel.LastClickedLevelDetailId()).click();
                        }
                        if (SIWViewModel.ErrorStatus() == 1) {
                            SIWViewModel.ErrorStatus(0);
                            $('#RfTab ul #' + SIWViewModel.LastClickedLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                            $('#RfTab ul #' + data.LevelID()).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SIWViewModel.SaveButtonClick(false);
                            SIWViewModel.countLevelEntry(0);
                            $('#RfTab ul #' + SIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                            $('#RfTab ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                            //for (var i = 0; i < SIWViewModel.RiskAreaList().length; i++) {
                            //    if (event.currentTarget.id == SIWViewModel.RiskAreaID()) {

                            //    }
                            //    else {
                            BusinessLevelTabClick(data, event);
                            //    }
                            //}
                        }
                    }
                    else {
                        SIWViewModel.countLevelEntry(0);
                        $('#RfTab ul #' + SIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                        $('#RfTab ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                        BusinessLevelTabClick(data, event);
                    }
                });
            }
            else {
                SIWViewModel.SaveButtonClick(false);
                SIWViewModel.countLevelEntry(0);
                $('#RfTab ul #' + SIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                $('#RfTab ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                BusinessLevelTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelTabClick() method in SANCInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelDetailTabClick(data) {
        try {
            SIWViewModel.ClickedLevelDetailId(data.LevelID());
            SIWViewModel.ClickedLevelDetailName(data.LevelName() + '- OVERALL');
            if (data.LevelID().toString().includes('OVERALL')) {
                SIWViewModel.WeightingsType('BULOverall');

                GetBUlevelOverallWeightings();
                if (SIWViewModel.LastClickedLevelDetailId() == 'LevelOverall') {
                    var id = document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId());
                    if (id != null && id != undefined && id != '') {
                        document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                    }
                    for (var i = 0; i < SIWViewModel.RiskAreaList().length; i++) {
                        document.getElementById('SANCTabDiv-' + SIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                    }
                    var idRA = document.getElementById('SANCTabDiv-' + SIWViewModel.RAId());
                    if (idRA != null && idRA != undefined && idRA != '') {
                        document.getElementById('SANCTabDiv-' + SIWViewModel.RAId()).innerHTML = "";
                        $('#SANCTabDiv-' + SIWViewModel.RAId()).hide();
                    }
                }
                SIWViewModel.LastClickedLevelDetailId(SIWViewModel.ClickedLevelDetailId());
                var id = document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId());
                if (id != null && id != undefined && id != '') {
                    document.getElementById('SANCTabDiv-' + SIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                }
            }
            else {
                getAllBusinessUnitlowestLevels(data.DetailId());
            }
            addNewDivTabBULevel(data.LevelID());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetailTabClick() method in SANCInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    //---------------------------------------------------------------------Model Definition Ends Here------------------------------------------------------------------------------
});
